import _default from './Icon';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/es/elements/Icon/index.js
// module id = 28
// module chunks = 0